import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import authInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    return [day, month, year].join('-');
  }
  
  class ExpeditingApprovedPOAcceptance extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        
        allChecked: false,
        supplierName: "ABC Tech Inc.",
        select: true,
        checkbox:false,
        open: false,
        checked: [],
        opacity:"",
        comments:'',
        formattedData: [],
        selectAll: false,
        modal: false,
        ApproveScheduleModal: false,
        lorryreceiptmodal:false,
        multiCollapseIndex:"",
        array2: [
            
            {  value: 2, id:2, PONumber: "4700026943", PoItem: "11" , PoDate: "11-01-2020" , status: "PO Acceptance Approved",statusExp: "Delivery Scedule Uploaded", WBSNo: "A0XXX0",POAmount:"30009",  Location:"ABC",PODocument:"Document1.pdf",POAcceptanceDocument:"Document2.pdf",Comments:"ABC" , DeliverySchedule:"DeliverySchedule1.xlsx" },
            {  value: 3, id:3, PONumber: "4700026943", PoItem: "12" , PoDate: "12-03-2020" , status: "PO Acceptance Approved",statusExp: "Delivery Scedule Uploaded", WBSNo: "AQUXXX",POAmount:"50009",  Location:"ABC",PODocument:"Document1.pdf",POAcceptanceDocument:"Document2.pdf",Comments:"ABC" , DeliverySchedule:"DeliverySchedule1.xlsx"  },
            
        ]       
      }
      // this.dateformate = this.dateformate.bind(this);
     
      this.comments = this.comments.bind(this);
      this.togglebutton = this.togglebutton.bind(this); 
      this.handleChange = this.handleChange.bind(this);
      this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
      this.approveschedulemodal= this.approveschedulemodal.bind(this);
      this.modal= this.modal.bind(this);
    
    }

  



    action1() {
             this.setState({ action1: false });
             } 

    togglebutton=(Index)=> {  
      
      var multiCollapseIndex = this.state.multiCollapseIndex
  
      if(multiCollapseIndex!=Index || multiCollapseIndex==''){
        this.setState({multiCollapseIndex:Index})
    }}

    handleChange = () => {   
      var selectAll = !this.state.selectAll;
      this.setState({ selectAll: selectAll });
      var checkedCopy = [];
      this.state.array2.map(function(e, index) {
        checkedCopy.push(selectAll);
      });
      this.setState({
        checked: checkedCopy
      });
    };

    handleSingleCheckboxChange = index => {
      console.log(index);
      var checkedCopy = this.state.checked;
      checkedCopy[index] = !this.state.checked[index];
      if (checkedCopy[index] === false) {
        this.setState({ selectAll: false });
      }
      this.setState({
        checked: checkedCopy
      });
    };
         modal() {
            this.setState({ modal: !this.state.modal });
              if(this.state.DeliverScheduleModal==true){
                this.setState({ DeliverScheduleModal: !this.state.DeliverScheduleModal });
              }
              if(this.state.ApproveScheduleModal==true){
                this.setState({ ApproveScheduleModal: !this.state.ApproveScheduleModal });
              }
              if(this.state.ReviseScheduleModal==true){
                this.setState({ ReviseScheduleModal: !this.state.ReviseScheduleModal });
              }   
                if(this.state.modal ==true){
                    this.setState(
                    {opacity:""}
                    )
                   }
                else{
                    this.setState(
                       {opacity:"0.2"} 
                    )}}


    approveschedulemodal() {
       this.setState({ApproveScheduleModal: !this.state.ApproveScheduleModal });     
       this. setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved "}) ;
      this. setState({headertitle :"Delivery Schedule Approved Successfully"}) ;            
      if(this.state.ApproveScheduleModal ==true){
         this.setState(
          {opacity:""}
            )
            }
     else{
      this.setState(
        {opacity:"0.2"} 
          )}}


    toggleSuccessModal(e){
      this.setState({ modal: !this.state.modal });
      if(this.state.modal ==true){
        this.setState(
      {opacity:""}
        )}
    else{
        this.setState(
           {opacity:"0.2"} 
        ) }
      }

      comments(event) { 
        this.setState({comments: event.target.value})
        // console.log(this.state.comments,"comments") ;
       }


      handleClick = () => {
        var datePattern= document.getElementById('myDate').value;
        document.getElementById("demo").innerHTML=datePattern;
      }
      

    render()
    {
       var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        return(
                        
            <div className="Container-fluid pageheight"  >
               
               <div className="Container-fluid p-4" >

                 {/* ---------Approve DeliverScheduleModal by Expeditor Start-------- */}
                {this.state.array2.map((value,index)=>(
                   <Modal isOpen={this.state.ApproveScheduleModal}>

                        <ModalHeader HeaderStyle="modalheaderWide modal-header">
                            <h4 style={{color:'black', textAlign:' center',verticalAlign: 'middle'}}>Approve Delivery Schedule</h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.approveschedulemodal} style={{color:'black'}}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>


                        <ModalBody Style="modal-body modalbodysWide">
                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>PO No : </b></div>
                                    <div className="col">{value.PONumber}</div>
                                    </div>
                                </div>

                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>Item No : </b></div>
                                    <div className="col">{value.PoItem}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                            
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>PO Date : </b></div>
                                    <div className="col">{formatDate(value.PoDate)}</div>
                                    </div>
                                </div>

                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>Payment Term : </b></div>
                                    <div className="col">Y001</div>
                                    </div>
                                </div>                      
                            </div>
                             <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>Supplier Name : </b></div>
                                    <div className="col">ABC Metallics</div>
                                    </div>
                                </div>

                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>PO Quantity : </b></div>
                                    <div className="col">50</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>WBS No. : </b></div>
                                    <div className="col">XXX</div>
                                    </div>
                                </div>
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>Location : </b></div>
                                    <div className="col">Gurgaon</div>
                                    </div>
                                </div>                                                               
                            </div>

                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>PO Document : </b></div>
                                    <div className="col">  
                                    PO47887493.pdf                             
                                    </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col"><b>PO Acceptance Document : </b></div>
                                    <div className="col">
                                    POAcceptanceDocument1.pdf
                                    </div>
                                    </div>
                                </div>
                            </div>

             

                            <div className="row">
                                <div className="col pt-2">
                                <div className="row">
                                    <div className="col"><b>Delivery Schedule : </b></div>
                                    <div className="col">
                                    DeliverSchedule1.xlsx
                                    </div>
                                    </div>
                                </div>
                            </div>

                            

                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col-md-6"><b>Comments : </b></div>
                                    <div className="col"> 
                                    
                                         <input type="text" className="form-control" value={this.state.commentsexpeditor} onChange={this.handleCommentsExpeditor} />
                                               
                                     </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col-md-6"><b>Set Expected Delivery Date : </b></div>
                                    <div className="col"> 
                                    
                                    <input type='date' id="myDate" value={this.state.value} />
                                      <button onClick={this.handleClick} className='btn-border'> <p id="demo"></p></button> 
                                               
                                     </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col pt-2">
                                    <div className="row">
                                    <div className="col-md-6"><b>Set Document Submission Due Date : </b></div>
                                    <div className="col"> 
                                    
                                    <input type='date' id="myDate" value={this.state.value} />
                                      <button onClick={this.handleClick} className='btn-border'> <p id="demo"></p></button> 
                                               
                                     </div>
                                    </div>
                                </div>
                            </div>

                        </ModalBody>
                      <ModalFooter FooterStyle="modal-footer modalfooterWide">
                            <div>
                           
                                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">OK</button>
                              
                            <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.approveschedulemodal} type="submit">Cancel</button>
                                        
                            </div>
                
                       </ModalFooter>
                  </Modal>
               ))}
                {/* --------Approve DeliverScheduleModal by Expeditor  End-------------- */}
                <div className="row pr-4" >
                    <div className="col-md-8  ">
                      
                     <Link  to ={{ pathname: '',state : {}}}> 
                       <div><button className="btn2 btn-sms1 mt-2 float-right mr-4 "onClick={this.approveschedulemodal }  disabled={this.state.checked.length==0 ? true : false} >Approve Delivery Schedule</button></div>
                    </Link>
                  </div>
                    
                    <div className="col pt-2  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                
              <div className="row-md-8 pr-4">
                <div className="col ">
                  
                    <div className="row  headerbar ">
                   
                          <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar">
                            <input type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll}/>                           
                          </div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Amount</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status </div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar">Action </div>
                    </div>
                    
                    
                  

                        {this.state.array2.map((element,Index)=>
                            <div className={Index%2==0? 'row border ':'row  background '} 
                             onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                          
                             <div className="col-md-1 pt-2 pb-2 borderheaderbar">    
                                <input key={element.id} type='checkbox'name={element.PoName} value={element.PoName} checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)} />        
                             </div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PONumber}</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign ">{element.PoItem}</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign ">{element.POAmount}</div>
                            {roles[5]?<>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">{element.status}</div></>
                            :<><div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">{element.statusExp}</div></>
                             }
                                <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">
                                <Link  to ={{ pathname: '/ExpeditingPOAcceptanceTrail',state : {} }}> 
                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                </Link> 
                                 </div>
                          
                           
                            
                      
                         <div style={{maxWidth:"1400px"}} className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                                  <form>
                                        <div></div>
                                           <div className="row">
                                              <div className="col-md-3">
                                                  <b>WBS No: </b>
                                               </div>
                                               <div className="col">
                                                {element.WBSNo}
                                                </div>
                                                
                                               <div className="col-md-3">
                                                 <b>Location: </b>
                                               </div>
                                               <div className="col">
                                                {element.Location}
                                               </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-3">
                                                  <b>PO Created On </b>
                                                </div>
                                                <div className="col">
                                                {formatDate(element.PoDate)}
                                                </div>
                                                
                                                <div className="col-md-3">
                                                 <b>PO Document: </b>
                                                </div>
                                                <div className="col">
                                                 {element.PODocument}
                                                </div>
                                            </div> 
                                            
                                            <div className="row">
                                                <div className="col-md-3">
                                                  <b>PO Acceptance Document: </b>
                                                </div>
                                                <div className="col">
                                                {element.POAcceptanceDocument}
                                                </div>
                
                                                </div> 
                                                

                                              <div className="row ">
                                                <div className="col-md-3">
                                                    <b>Comments: </b>
                                                </div>
                                                <div className="col">
                                                {element.Comments}
                                                </div>
                                              </div> 

                                              <div className="row ">
                                                <div className="col-md-3">
                                                    <b>Delivery Schedule: </b>
                                                </div>
                                                <div className="col">
                                                {element.DeliverySchedule}
                                                </div>
                                              </div>
                                              
                                   </form> 
                             </div>
                          </div>
                    )}  
                        <br/> 
                        <br/>        
                   
                   
                  </div>
            </div>
        </div>
      </div>
    )
  }
}

export default ExpeditingApprovedPOAcceptance;